import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getInventoryClient, liveInventoryConfigured, readLiveInventory } from "../../utils/liveInventory";
import AdminPage from "../../pages/AdminPage";

export default function AdminAccess() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(liveInventoryConfigured);
  const [snapshot, setSnapshot] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const activeUser = useRef(null);

  useEffect(() => {
    if (!liveInventoryConfigured) return undefined;
    let active = true;
    let subscription;
    try {
      const client = getInventoryClient();
      client.auth.getSession().then(({ data, error }) => {
        if (!active) return;
        if (error) setError(error.message);
        activeUser.current = data?.session?.user.id || null;
        setSession(data?.session || null); if (!data?.session) setLoading(false);
      }).catch(err => { if (active) { setError(err.message); setLoading(false); } });
      subscription = client.auth.onAuthStateChange((_event, next) => {
        if (!active) return;
        if (next?.user.id && next.user.id === activeUser.current) return;
        activeUser.current = next?.user.id || null;
        setSnapshot(null); setSession(next); setLoading(Boolean(next));
      }).data.subscription;
    } catch (err) { setError(err.message); setLoading(false); }
    return () => { active = false; subscription?.unsubscribe(); };
  }, []);

  useEffect(() => {
    if (!session) return undefined;
    let active = true;
    setLoading(true);
    (async () => {
      try {
        const { data, error } = await getInventoryClient().rpc("is_inventory_admin");
        if (error) throw new Error(error.message);
        if (!data) throw new Error("This account does not have permission to manage inventory.");
        const snapshot = await readLiveInventory();
        if (active) { setSnapshot(snapshot); setError(""); }
      } catch (err) { if (active) { setSnapshot(null); setError(err.message); } }
      finally { if (active) setLoading(false); }
    })();
    return () => { active = false; };
  }, [session]);

  const signOut = async () => {
    setBusy(true);
    try { const { error } = await getInventoryClient().auth.signOut(); if (error) throw error; setSnapshot(null); setSession(null); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  if (!liveInventoryConfigured) return <AdminPage />;
  if (loading) return <main className="inventoryAdmin" role="status">Checking admin access…</main>;
  if (snapshot && session) return <><div className="inventoryAdmin inventoryAccount">Signed in as {session.user.email}<button disabled={busy} onClick={signOut}>Sign out</button></div><AdminPage key={session.user.id} liveInitial={snapshot} /></>;
  return <main className="inventoryAdmin inventoryLogin"><Link to="/">Back to shop</Link><h1>Admin login</h1><p>Sign in with your inventory admin account.</p>
    {error && <p className="inventoryError" role="alert">{error}</p>}
    {session ? <button disabled={busy} onClick={signOut}>Sign out</button> : <form onSubmit={async e => {
      e.preventDefault(); setBusy(true); setError("");
      try { const { error } = await getInventoryClient().auth.signInWithPassword({ email, password }); if (error) throw error; setPassword(""); }
      catch (err) { setError(err.message); }
      finally { setBusy(false); }
    }}><label>Email<input type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required /></label><label>Password<input type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required /></label><button type="submit" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button></form>}
  </main>;
}
